export default function onBlur (e, callback) {
    var currentTarget = e.currentTarget;

    setTimeout(function() {
        if (!currentTarget.contains(document.activeElement)) {
            callback();
        }
    }, 0);
}